@if (user$ | async; as user) {
  @if ((node$ | async)?.children[0]; as nodes) {
    <ul id="accordion" class="accordion">
      @for (menu of nodes.children; track menu; let i = $index) {
        @if (shouldShowMenu(menu, user)) {
          <li [class.active]="menu.active">
            @if (menu.url) {
              <div
                class="menu d-flex align-items-center"
                [attr.aria-hidden]="true"
                tabindex="0"
                role="button"
                (click)="onMenuClick($event, menu, i)"
                (keydown.enter)="onMenuClick($event, menu, i)"
                (keydown.space)="onMenuClick($event, menu, i)"
                [class.highlight-menu]="menu.isCurrentUrl"
                >
                <cx-generic-link
                  [class]="menu.children && menu.children.length > 0 ? 'd-inline-flex' : 'd-flex'"
                  [url]="getMenuUrl(menu, user)"
                  [target]="menu.target"
                  >
                  @if (menu.media) {
                    <cx-media [container]="menu.media"></cx-media>
                  }
                  <span>{{ menu.title }}</span>
                </cx-generic-link>
                @if (menu.children && menu.children.length > 0) {
                  <i class="fa"></i>
                }
              </div>
            }
            @if (menu.children && menu.children.length > 0) {
              <ul
                class="submenu"
                #submenu
                [style.height.px]="menu.active ? submenu.scrollHeight : 0"
                >
                @for (submenu of menu.children[0].children; track submenu) {
                  @if (shouldShowMenu(submenu, user)) {
                    <li [class.highlight-menu]="submenu.isCurrentUrl" (click)="onSubmenuClick($event, submenu)">
                      <cx-generic-link
                        class="d-block"
                        [url]="resolveUrl(submenu.url, user)"
                        [target]="submenu.target"
                        >
                        @if (submenu.media) {
                          <cx-media [container]="submenu.media"></cx-media>
                        }
                        <span>{{ submenu.title }}</span>
                      </cx-generic-link>
                    </li>
                  }
                }
              </ul>
            }
          </li>
        }
      }
    </ul>
  }
}
